<template>
  <div id="app">
    <header v-if="showLogo && placeContext && placeContext.logo_path" class="app-header">
      <div class="container">
        <div class="text-center">
          <router-link to="/">
            <img alt="logo" :src="placeContext.logo_path" class="app-logo" :style="logoStyle" />
          </router-link>
        </div>
      </div>
    </header>

    <main class="app-main">
      <router-view v-if="placeContext"></router-view>
      <div v-else class="container py-5 text-center">
        <b-spinner variant="secondary"></b-spinner>
      </div>
    </main>

    <CustomCSS
      v-if="placeContext && placeContext.workshop_front_custom_css"
      :custom-css="placeContext.workshop_front_custom_css"
    />
  </div>
</template>

<script>
import ApiService from './services/api'
import CustomCSS from './components/CustomCSS.vue'

export default {
  name: 'App',

  components: {
    CustomCSS
  },

  created() {
    // Always initialize ApiService (with or without context key)
    ApiService.init(this.$route.query.c || null)

    const eventLocale = this.$route.query.f ? this.$route.query.f.split(',') : ['fr']
    this.$store.dispatch('setWorkshopsLocales', eventLocale)

    if (this.$route.query.l) {
      this.$i18n.locale = this.$route.query.l
    }

    // pc = code du magasin imposé : seuls ses événements sont affichés, sans filtre des lieux
    if (this.$route.query.pc) {
      this.$store.dispatch('setPlaceCode', String(this.$route.query.pc))
    }
  },

  mounted() {
    ApiService.getPlaceContext()
      .then(response => {
        this.$store.dispatch('setPlaceContext', response.data)
      })
      .catch(() => {
        this.$swal(this.$i18n.t('errors.base'))
      })

    ApiService.fetchPlaces()
      .then(response => {
        const placeCode = this.$store.state.placeCode
        const places = placeCode
          ? response.data.filter(place => String(place.code) === placeCode)
          : response.data
        this.$store.dispatch('setPlaces', places)
        // Select all places by default
        this.$store.dispatch('setSelectedPlaces', [...places])
      })
  },

  computed: {
    placeContext() {
      return this.$store.state.placeContext
    },
    showLogo() {
      return this.$route.query.logo === '1'
    },
    // logoH = hauteur forcée du logo en pixels, largeur en auto
    logoStyle() {
      const height = parseInt(this.$route.query.logoH, 10)
      return height > 0 ? { height: `${height}px`, width: 'auto', maxHeight: 'none', objectFit: 'contain' } : null
    }
  }
}
</script>

<style lang="scss">
@import './scss/app.scss';
</style>
